module.exports = __webpack_public_path__ + "static/media/dashboard.14bfbfb8.svg";